import { Box, Container, Paper, Stack, Typography } from '@mui/material'
import { useRef } from 'react'
import { setOneTrustState } from '@/features/auth/slice'
import { getMediaState } from '@/features/media/slice'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'

export default function Footer() {
  const dispatch = useAppDispatch()
  const { isPerkins } = useAppSelector(getMediaState)
  const ref = useRef<HTMLDivElement>(null)
  const platformName = isPerkins ? 'Perkins' : 'Caterpillar'

  return (
    <Container
      ref={ref}
      maxWidth={false}
      disableGutters
      sx={{ position: 'sticky', bottom: 0 }}
    >
      <Paper>
        <Container maxWidth="xl">
          <Stack direction="row" justifyContent="space-between" px={2} py={0.5}>
            <Box>
              <Typography variant="caption">
                <a
                  className="ot-sdk-show-settings"
                  href="#"
                  role="button"
                  tabIndex={0}
                >
                  Cookie Settings
                </a>
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption">
                © {new Date().getFullYear()} {platformName} All Rights Reserved
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption">
                {platformName}: <strong>Non-Confidential</strong>
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption">
                <a
                  href="#"
                  role="button"
                  onClick={(e) => {
                    e.preventDefault()
                    dispatch(setOneTrustState({ open: true }))
                  }}
                >
                  Privacy
                </a>
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Paper>
    </Container>
  )
}
